<div class="min-h-screen flex flex-col">
  <app-navbar></app-navbar>

  <main class="w-full flex-1 pb-[90px] md:pb-[90px] lg:pb-0">
    <router-outlet></router-outlet>
  </main>

  <app-public-footer></app-public-footer>
</div>

@if (toastService.message(); as msg) {
  <div class="pointer-events-none fixed inset-x-0 top-[80px] z-[300] flex justify-center px-[16px]">
    <div class="pointer-events-auto w-full max-w-[400px]">
      <app-alert [variant]="msg.variant" [message]="msg.text" (closed)="toastService.clear()"></app-alert>
    </div>
  </div>
}

<app-quotation-progress-toast></app-quotation-progress-toast>
